import { PayloadAction } from "@reduxjs/toolkit";
import { Message } from "../../../../utl/models/Message";
import { FinanceState } from "../models/FinanceState";

const setMessage = (state: FinanceState, action: PayloadAction<Message>) => {
    state.finance.message = action.payload.message;
}

export default setMessage;